// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-console */
// Note that window.localStorage can be null in android's webView

// Boolean(window.localStorage) is not enough
// because localstorage can be disabled for example by disabling cookies
// (Failed to read the 'localStorage' property from 'Window': Access is denied for this document)
const localStorageEnabled = (): boolean => {
  const test = "localStorageEnabled"
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    return false
  }
}

export const HAS_LOCAL_STORAGE =
  typeof window !== "undefined" && "localStorage" in window && localStorageEnabled()

export function setItem(key: string, value: string) {
  if (HAS_LOCAL_STORAGE) {
    localStorage.setItem(key, value)
  }
}

export function getItem(key: string): string {
  if (HAS_LOCAL_STORAGE) {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return localStorage.getItem(key) || ""
  }
  return ""
}

export function getObjectItem(
  key: string,
): // Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
| {
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any
    }
  | null
  | undefined {
  if (HAS_LOCAL_STORAGE) {
    const value = localStorage.getItem(key)
    if (value) {
      try {
        return JSON.parse(value)
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        console.warn(`${key} is not a valid JSON string`)
      }
    }
  }
  return null
}

export function removeItem(key: string) {
  if (HAS_LOCAL_STORAGE) {
    localStorage.removeItem(key)
  }
}
